import axios from 'axios';
import { UpdateItineraryRequest } from '../models/itinerary';
export class ItineraryApiClient {
  private webApiUrl: string;

  constructor(webApiUrl: string) {
    this.webApiUrl = webApiUrl;
  }

  public getItinerary = (id: string, pin: string) => {
    const getItineraryUrl = new URL(
      `itinerary/${id}/${pin}`,
      this.webApiUrl,
    ).toString();

    return axios.get(getItineraryUrl).catch((error) => error.response);
  };

  public getIntlItinerary = (id: string, pin: string) => {
    const getIntlItineraryUrl = new URL(
      `itinerary/intl/${id}/${pin}`,
      this.webApiUrl,
    ).toString();

    return axios.get(getIntlItineraryUrl).catch((error) => error.response);
  };

  public updateItinerary = (
    id: string,
    pin: string,
    updateRequest: UpdateItineraryRequest,
  ) => {
    const updateItineraryUrl = new URL(
      `itinerary/accept/${id}/${pin}`,
      this.webApiUrl,
    ).toString();

    return axios
      .post(updateItineraryUrl, updateRequest)
      .catch((error) => error.response);
  };
}
